import '/home/deployer/apps/zeichenfabrik-production/shared/vendor/bundle/ruby/2.7.0/gems/mountable_file_server-3.0.3/vendor/assets/javascripts/mountable_file_server.js';

const MountableFileServerUploader = window.MountableFileServerUploader;

const Uploader = function(options) {
  options = options || {};
  options.url = options.url || '/file-uploads';

  return new MountableFileServerUploader(options);
};

delete window.MountableFileServerUploader;

export { Uploader };
